import React from "react";
import { FlatList as RNFlatList, FlatListProps } from "react-native";

type FlatListComponent = (props: FlatListProps<any>) => JSX.Element;
const FlatList: FlatListComponent = (props) => <RNFlatList {...props} />;

export default FlatList;
